import {
	TERM_SELECT_AS_TARGET,
	TERM_SELECT_AS_IGNORED_RELATED,
	TERM_SELECT_AS_INCLUDE_SPECIFIC,
	TERM_SELECT_AS_IGNORE_SPECIFIC,
	BUILD_CONCEPT_UNSAVED,
	BULD_CONCEPT_LOADING_END,
	RANGE_FILTER_SAVING_START,
	RANGE_FILTER_SAVING_END,
	BUILD_CONCEPT_SAVE_CURRENT_UUID,
	BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
	BUILD_CONCEPT_CLEAR_TERMS,
	BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
	BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY,
	BUILD_CONCEPT_UPDATE_DOCUMENT_DATE,
	BUILD_CONCEPT_SET_SOURCE_FILTER,
	BUILD_CONCEPT_FORCE_FILTER_REFRESH,
	BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
	BUILD_CONCEPT_SEARCHING_DOCS,
	BUILD_CONCEPT_IS_LOADING_DOCS,
	BUILD_CONCEPT_CLEAR_BUTTON,
	REQUEST_SAVED_BUILD_CONCEPTS,
	REQUEST_LOAD_CONCEPT_API,
	REQUEST_SEARCH_FOR_TOPIC_API,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT,
	REQUEST_SAVE_CONCEPT,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS,
	REMOVE_CONCEPT,
	GET_SAVED_BUILD_CONCEPT_ON_API,
	SET_CURRENT_FILTER,
	SELECTED_BUILD_CONCEPT,
	BUILD_CONCEPT_CLEAR_ALL,
	UPDATE_BUILD_CONCEPT_METADATA,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED_CLEAR,
	REQUEST_SAVE_CONCEPT_SUCCESS,
	REQUEST_SAVE_CONCEPT_FAILED,
	REQUEST_SAVE_CONCEPT_CLEAR,
	SET_P_SEARCH_API_CALL,
	RESET_P_SEARCH_API_CALL,
	SET_SEARCH_TERMS,
	SET_REFRESH_TERM_LIST,
	SET_TARGET_TERMS,
} from "../types"

export const clearTerms = () => ({
	type: BUILD_CONCEPT_CLEAR_TERMS,
	payload: null,
})

export const setSearchingDocs = (value) => ({
	type: BUILD_CONCEPT_SEARCHING_DOCS,
	payload: value,
})

export const setCurrentSearchingDocs = (value) => ({
	type: BUILD_CONCEPT_SEARCHING_DOCS,
	payload: value,
})

export const setHighlightConcepts = (concepts) => ({
	type: BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
	payload: concepts,
})

export const updateHighlightConcepts = (concepts) => ({
	type: BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
	payload: concepts,
})

export const setCurrentUUID = (uuid) => ({
	type: BUILD_CONCEPT_SAVE_CURRENT_UUID,
	payload: uuid,
})

export const saveCurrentUUID = (uuid) => ({
	type: BUILD_CONCEPT_SAVE_CURRENT_UUID,
	payload: uuid,
})

export const starSavingRange = () => ({
	type: RANGE_FILTER_SAVING_START,
	payload: null,
})

export const endSavingRange = () => ({
	type: RANGE_FILTER_SAVING_END,
	payload: null,
})

export const loadingEnd = () => ({
	type: BULD_CONCEPT_LOADING_END,
	payload: false,
})

export const changeTermTarget = (term, add) => ({
	type: TERM_SELECT_AS_TARGET,
	payload: { term: term, add: add },
})

export const setSearchTerms = (data) => ({
	type: SET_SEARCH_TERMS,
	payload: data,
})

export const setRefreshTermList = (data) => ({
	type: SET_REFRESH_TERM_LIST,
	payload: data,
})

export const setTargetTerms = (data) => ({
	type: SET_TARGET_TERMS,
	payload: data,
})

export const changeIgnoreRelated = (term, add) => ({
	type: TERM_SELECT_AS_IGNORED_RELATED,
	payload: { term: term, add: add },
})

export const changeIncludeSpecific = (term, add) => ({
	type: TERM_SELECT_AS_INCLUDE_SPECIFIC,
	payload: { term: term, add: add },
})

export const changeIgnoreSpecific = (term, add) => ({
	type: TERM_SELECT_AS_IGNORE_SPECIFIC,
	payload: { term: term, add: add },
})

export const setUnsaveFlag = (value) => ({
	type: BUILD_CONCEPT_UNSAVED,
	payload: value,
})

export const setUnsaveData = (value) => ({
	type: BUILD_CONCEPT_UNSAVED,
	payload: value,
})

export const setRequestDocuments = (value) => ({
	type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
	payload: value,
})

export const setForceCloudRefresh = (value) => ({
	type: BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
	payload: value,
})

export const refreshCloud = (value) => ({
	type: BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
	payload: value,
})

export const setCloudTagsUpdated = (value) => ({
	type: BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
	payload: value,
})

export const setForceFilterRefresh = (value) => ({
	type: BUILD_CONCEPT_FORCE_FILTER_REFRESH,
	payload: value,
})

export const setCancelFilterRangerUpdated = (value) => ({
	type: BUILD_CONCEPT_FORCE_FILTER_REFRESH,
	payload: value,
})

export const updateDocumentPriority = (document_id, priority) => ({
	type: BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY,
	payload: { id: document_id, priority: priority },
})

export const updateDocumentDate = (document_id, newdate) => ({
	type: BUILD_CONCEPT_UPDATE_DOCUMENT_DATE,
	payload: { id: document_id, date: newdate },
})

export const setCurrentSourceFilter = (filter) => ({
	type: BUILD_CONCEPT_SET_SOURCE_FILTER,
	payload: filter,
})

export const setIsLoadingDocs = (value) => ({
	type: BUILD_CONCEPT_IS_LOADING_DOCS,
	payload: value,
})

export const setClearButtonBuild = (value) => ({
	type: BUILD_CONCEPT_CLEAR_BUTTON,
	payload: value,
})

export const setBuildConceptClearAll = () => ({
	type: BUILD_CONCEPT_CLEAR_ALL,
})

export const requestSavedBuildConcepts = (force = false) => ({
	type: REQUEST_SAVED_BUILD_CONCEPTS,
	payload: {
		force: force,
	},
})

export const requestLoadConceptFromAPI = (ext_id, refreshBuildHighlight = false) => ({
	type: REQUEST_LOAD_CONCEPT_API,
	payload: {
		ext_id: ext_id,
		refreshBuildHighlight: refreshBuildHighlight,
	},
})

export const searchForTopicAPI = (topic) => ({
	type: REQUEST_SEARCH_FOR_TOPIC_API,
	payload: topic,
})

export const loadDocumentsOfConcept = (positive_terms, negative_terms, filtersObject, cancelToken = null) => ({
	type: REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT,
	payload: {
		positive_terms: positive_terms,
		negative_terms: negative_terms,
		filtersObject: filtersObject,
		cancelToken: cancelToken,
	},
})

export const loadDocumentsOfConceptWithDocs = (payload) => ({
	type: REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS,
	payload,
})

// export const getAllDocumentsRequest = (data) => ({
// 	type: GET_ALL_DOCUMENTS_REQUEST,
// 	payload: data,
// })

// export const loadDocumentsOfConceptWithDocsSuccess = (data) => ({
// 	type: GET_ALL_DOCUMENTS_REQUEST_SUCCESS,
// 	payload: data,
// })

export const loadDocumentsOfConceptWithDocsFailed = (data) => ({
	type: REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED,
	payload: data,
})

export const loadDocumentsOfConceptWithDocsClear = (data) => ({
	type: REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED_CLEAR,
})

export const saveConceptOnNewAPI = (new_concept) => ({
	type: REQUEST_SAVE_CONCEPT,
	new_concept: new_concept,
})

export const saveConceptSuccess = (data) => ({
	type: REQUEST_SAVE_CONCEPT_SUCCESS,
	payload: data,
})
export const saveConceptFailed = (data) => ({
	type: REQUEST_SAVE_CONCEPT_FAILED,
	payload: data,
})
export const saveConceptClear = () => ({
	type: REQUEST_SAVE_CONCEPT_CLEAR,
})

export const removeConcept = (ext_id, showSwal = true) => ({
	type: REMOVE_CONCEPT,
	payload: {
		ext_id: ext_id,
		showSwal: showSwal,
	},
})

export const getSavedBuildConceptsOnAPI = (force = false) => ({
	type: GET_SAVED_BUILD_CONCEPT_ON_API,
	payload: {
		force: force,
	},
})

export const setCurrentFilter = (filter) => ({
	type: SET_CURRENT_FILTER,
	payload: {
		filter: filter,
	},
})

export const setSelectedBuildConcept = (data) => ({
	type: SELECTED_BUILD_CONCEPT,
	payload: data,
})

//update concept metadata
export const updateConceptMetadata = (data) => ({
	type: UPDATE_BUILD_CONCEPT_METADATA,
	payload: data,
})

export const setPsearchApiCall = () => ({
	type: SET_P_SEARCH_API_CALL,
})

export const resetPsearchApiCall = () => ({
	type: RESET_P_SEARCH_API_CALL,
})
